/**
 * @generated SignedSource<<68b08f99189692fcdc2e7aa8b0a3af38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "FondyRecurringResponse",
    "kind": "LinkedField",
    "name": "fondyRecurring",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FondyRecurringResponseInner",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseRecurringPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseRecurringPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7be0da878cb128278914c2f8d66717f0",
    "id": null,
    "metadata": {},
    "name": "ImpulseRecurringPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseRecurringPaymentCheckoutPagesMutation(\n  $request: FondyRecurringRequestInput\n) {\n  fondyRecurring(request: $request) {\n    response {\n      responseStatus\n    }\n  }\n}\n"
  }
};
})();

node.hash = "04c2ef651461aef320a34b779c2a1aa6";

module.exports = node;
